<template>
    <div class="flex items-center space-x-4 text-gray-500 text-sm">
        <div class="flex items-center space-x-1">
            <Calendar class="w-4 h-4" />
            <span>Publié le {{ publishedDate }}</span>
        </div>
        <span>•</span>
        <div class="flex items-center space-x-1">
            <User class="w-4 h-4" />
            <span>par {{ author }}</span>
        </div>
    </div>
</template>

<script setup>
import { Calendar, User } from 'lucide-vue-next'

defineProps({
    publishedDate: String,
    author: String
})
</script>
